
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-95dece24&scoped=true!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DemoSignup.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./DemoSignup.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-95dece24!../../node_modules/vue-loader/lib/selector?type=template&index=0!./DemoSignup.vue"),
  /* scopeId */
  "data-v-95dece24",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/page/DemoSignup.vue
// module id = 606
// module chunks = 0